import React, { useState, useEffect } from 'react';
import { FaUsers, FaClipboardList, FaChartLine, FaCrown } from 'react-icons/fa';
import EducationStatsChart from '../components/EducationStatsChart';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { FaGraduationCap, FaChartBar, FaMedal, FaPlusCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function EducationStatsBox() {
  const [stats, setStats] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    fetch("https://dev.sliitleo.org/Backend/get_education_statistics.php")
      .then(res => res.json())
      .then(data => {
        if (data.success) setStats(data.stats);
        else setError("Failed to load statistics");
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load statistics");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="empty-state">
        <div className="spinner lg" />
        <p>Loading statistics…</p>
      </div>
    );
  }
  if (error) return <div className="error-banner">{error}</div>;
  if (!stats) return null;

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Participants */}
        <div className="panel tile">
          <div className="tile-label"><FaUsers style={{ marginRight: 6 }} />Total Participants</div>
          <div className="tile-value num">{stats.total_users}</div>
        </div>
        {/* Quizzes Completed */}
        <div className="panel tile">
          <div className="tile-label"><FaClipboardList style={{ marginRight: 6 }} />Quizzes Completed</div>
          <div className="tile-value num">{stats.total_completed_quizzes}</div>
        </div>
        {/* Average Score */}
        <div className="panel tile">
          <div className="tile-label"><FaChartLine style={{ marginRight: 6 }} />Average Score</div>
          <div className="tile-value num">{stats.average_score}</div>
        </div>
        {/* Highest Score */}
        <div className="panel tile">
          <div className="tile-label"><FaCrown style={{ marginRight: 6 }} />Highest Score</div>
          <div className="tile-value num">{stats.highest_score}</div>
        </div>
      </div>
      <div style={{ marginTop: 'var(--sp-5)' }}>
        <EducationStatsChart stats={stats} />
      </div>
    </>
  );
}

function Education() {
  const user = JSON.parse(localStorage.getItem('user')) || {
    name: 'Unknown User',
    role: 'Member',
    image: '/default-user.png',
  };
  return (
    <>
      <Sidebar />
      <Topbar user={user} />
      <main className="lg:ml-64 mt-14 w-full px-4 sm:px-6 md:px-8 py-6 md:py-10">
        <div className="page-head">
          <div>
            <h1>
              <FaGraduationCap style={{ marginRight: 8, color: 'var(--accent)' }} />
              Education Admin <span style={{ color: 'var(--text-3)', fontWeight: 400 }}>/ Statistics</span>
            </h1>
          </div>
        </div>

        <div className="filter-row" style={{ flexWrap: 'wrap', marginBottom: 'var(--sp-6)' }}>
          <Link to="/education-statistics" className="btn btn-ghost btn-sm">
            <FaChartBar /> Statistics
          </Link>
          <Link to="/education-leaderboard" className="btn btn-ghost btn-sm">
            <FaMedal /> Leaderboard
          </Link>
          <Link to="/education-add-quiz-question" className="btn btn-primary btn-sm">
            <FaPlusCircle /> Add Quiz
          </Link>
        </div>

        <div className="panel" style={{ padding: 'var(--sp-5)' }}>
          <h2 style={{ fontSize: 14.5, fontWeight: 700, marginBottom: 'var(--sp-4)' }}>Education Statistics</h2>
          <EducationStatsBox />
        </div>
      </main>
    </>
  );
}

export default Education;
